import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {SUPPORTED_LANGUAGES, LANG_CODE_PATTERN} from './config/languages.js';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationTR from './locales/tr/translation.json';
import translationFA from './locales/fa/translation.json';
import translationAR from './locales/ar/translation.json';
import translationEL from './locales/el/translation.json';
import translationRU from './locales/ru/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    tr: {
        translation: translationTR
    },
    fa: {
        translation: translationFA
    },
    ar: {
        translation: translationAR
    },
    el: {
        translation: translationEL
    },
    ru: {
        translation: translationRU
    }
};

// Function to get language from URL
const getLanguageFromURL = () => {
    const path = window.location.pathname;
    const langMatch = path.match(LANG_CODE_PATTERN);
    if (langMatch) {
        const lang = langMatch[1];
        // Validate if it's a supported language
        if (SUPPORTED_LANGUAGES.includes(lang)) {
            return lang;
        }
    }
    return null;
};

// Function to detect the user's device language
const detectLanguage = () => {
    const userLang = navigator.language || navigator.userLanguage;
    if (userLang.includes('fa') || userLang.includes('ir')) {
        return 'fa';
    } else if (userLang.includes('tr')) {
        return 'tr';
    } else if (userLang.includes('ar')) {
        return 'ar';
    } else if (userLang.includes('el')) {
        return 'el';
    } else if (userLang.includes('ru')) {
        return 'ru';
    } else {
        return 'en';
    }
};

// Determine initial language: URL > localStorage > browser detection
export const getInitialLanguage = () => {
    return getLanguageFromURL() || localStorage.getItem('selectedLanguage') || detectLanguage();
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: getInitialLanguage(), // language to use
        fallbackLng: 'en', // fallback language

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
